import { render, staticRenderFns } from "./userFull.vue?vue&type=template&id=8f1c05c6&scoped=true&"
import script from "./userFull.vue?vue&type=script&lang=js&"
export * from "./userFull.vue?vue&type=script&lang=js&"
import style0 from "./userFull.vue?vue&type=style&index=0&id=8f1c05c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1c05c6",
  null
  
)

export default component.exports